import {callApi} from '@/lib/api/callApi';

/**
 * 登入
 * @param {String} identificationNo 帳號
 * @param {String} password 密碼
 * @returns {Promise} promise
 */
function login(identificationNo, password) {
  return callApi({
    category: 'auth',
    apiName: 'login',
    method: 'post',
    data: {
      identificationNo,
      password,
    },
    defaultError: '登入失敗',
  });
}

/**
 * 登出
 * @returns {Promise} promise
 */
function logout() {
  return callApi({
    category: 'auth',
    apiName: 'logout',
    method: 'post',
  });
}

/**
 * 寄送 Email 驗證信
 * @param {String} data 驗證資料
 * @returns {Promise} promise
 */
async function sendVerificationCode(data) {
  const res = await callApi({
    category: 'auth',
    apiName: 'send-verification-code',
    method: 'post',
    data,
    defaultError: '無法正常執行，請稍後再試。',
  });
  return res.data;
}

/**
 * 驗證信箱與驗證碼
 * @param {String} email 信箱
 * @param {String} code 驗證碼
 * @param {String} type 類型
 * @returns {Promise} promise
 */
async function verify({email, code, type}) {
  const res = await callApi({
    category: 'auth',
    apiName: 'verify',
    method: 'post',
    data: {email, code, type},
    defaultError: '驗證碼輸入錯誤，請再試一次',
  });
  return res.data;
}

/**
 * 更新密碼
 * @param {String} email 信箱
 * @param {String} code 驗證碼
 * @param {String} password 新密碼
 * @param {String} identificationNo 證件號碼
 * @returns {Promise} promise
 */
async function resetPassword({email, code, password, identificationNo}) {
  const res = await callApi({
    category: 'auth',
    apiName: 'password/reset',
    method: 'post',
    data: {email, password, code, identificationNo},
    defaultError: '密码更新失败',
  });
  return res.data;
}

export default {
  login,
  logout,
  sendVerificationCode,
  verify,
  resetPassword,
};
